import React from "react";
import PropTypes from "prop-types";
import Svg from "./Svg";
class CenterArrowSvg extends Svg {
  constructor(props) {
    super(props);
  }

  getPlainSVG(xrotation, color, opacity, hoveredId) {
    return (
      <svg
        width="122"
        height="75"
        viewBox="0 0 122 75"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
          <path
            d="M17.9414 11.1787C28.6901 4.48303 44.2041 0.591797 60.6061 0.591797C77.0082 0.591797 92.5403 4.47131 103.289 11.167L60.6061 37.5918L17.9414 11.1787Z"
            fill={hoveredId === '6206a77f4224d112304ca97b-620a97192ca9cb49244a0cd4' ? '#E9C139' : 'black'}
          />
          <path
            d="M60.0197 7.51761C60.4117 7.28429 60.8998 7.28312 61.293 7.51456L80.9908 19.1091L79.7226 21.2635L60.6624 10.0443L41.8145 21.2605L40.5361 19.1121L60.0197 7.51761Z"
            fill="white"
          />
          <path
            d="M103.27 63.4853C92.5208 70.181 77.0069 74.0723 60.6048 74.0723C44.2028 74.0723 28.6707 70.1927 17.9219 63.4971L60.6049 37.0723L103.27 63.4853Z"
            fill={hoveredId === '6206a77f4224d112304ca97b-620a9fbfc49e5f2c37a06f3e' ? '#E9C139' : 'black'}
          />
          <path
            d="M60.5485 64.6198L41.4883 53.4006L40.2202 55.555L59.9179 67.1495C60.3111 67.381 60.7991 67.3798 61.1912 67.1465L80.6749 55.552L79.3964 53.4036L60.5485 64.6198Z"
            fill="white"
          />
          <path
            d="M0 37.3632C0 26.8191 7.2854 17.8552 18.3242 10.9453L61 37.3632L18.3125 63.7891C7.27367 56.8792 0 47.9074 0 37.3632Z"
            fill={hoveredId === '6206a77f4224d112304ca97b-620a97b185a942f3ffdf432e' ? '#E9C139' : 'black'}
          />
          <path
            d="M11.3608 36.2891L30.8608 24.6849L32.1392 26.8333L14.4443 37.3633L32.1392 47.8933L30.8608 50.0417L11.3608 38.4375C10.9821 38.2121 10.75 37.804 10.75 37.3633C10.75 36.9226 10.9821 36.5145 11.3608 36.2891Z"
            fill="white"
          />
          <path
            d="M121.27 37.3633C121.27 47.9075 113.984 56.8714 102.945 63.7813L60.2695 37.3633L102.957 10.9375C113.996 17.8474 121.27 26.8192 121.27 37.3633Z"
            fill={hoveredId === '6206a77f4224d112304ca97b-620a94e14224d112304ca9dd' ? '#E9C139' : 'black'}
          />
          <path
            d="M90.4088 24.6848L109.909 36.2891C110.287 36.5145 110.52 36.9226 110.52 37.3633C110.52 37.804 110.287 38.2121 109.909 38.4375L90.4088 50.0417L89.1303 47.8933L106.825 37.3633L89.1303 26.8332L90.4088 24.6848Z"
            fill="white"
          />
      </svg>
    );
  }
}

CenterArrowSvg.propTypes = {
  primaryColor: PropTypes.string.isRequired,
  rotation: PropTypes.number.isRequired,
};

export default CenterArrowSvg;
